import React, { useEffect, useState } from 'react';
import SertifMagenta from '../assets/Sertifikat-Magenta.pdf';
import SertifSAFMCD2 from '../assets/SertifikatSAFMCD2.pdf';
import SertifSAFMCD1 from '../assets/SertifikatSAFMCD1.pdf';
import SertifHanaBank from '../assets/Sertifikat_HanaBank.pdf';

const Award: React.FC = () => {
    const [isMd, setIsMd] = useState(window.matchMedia('(min-width: 67.5rem)').matches);

    useEffect(() => {
        const mediaQuery = window.matchMedia('(min-width: 67.5rem)');
        const updateIsMd = () => {
            setIsMd(mediaQuery.matches);
        };
    
        mediaQuery.addListener(updateIsMd);
        return () => {
            mediaQuery.removeListener(updateIsMd);
        };
    }, []);

    const BulletCommon = "before:content-[''] before:absolute before:left-0 before:top-2 before:w-3 before:h-3 before:rounded-full before:border-2 before:border-textGrey";

    return(
        <div className=' flex flex-col justify-center items-center' >
            <br/>
            <p className='text-textGrey font-condensed text-center font-extrabold text-2xl' id="award" >
            AWARD & COMPETITION
            </p>
            <br/>
            {isMd ?(
            <ul className="text-textGrey text-lg text-left font-condensed font-extralight w-[65.625rem] h-auto list-none">
                <li className={`relative pl-6 ${BulletCommon}`}>
                [International] <b>2 Ganesha Karya 2025 </b> from ITB's Anugerah Citra Ganesha for International Competition Winner, November 2025
                </li>
                <li className={`relative pl-6 ${BulletCommon}`}>
                [International] <b>1 of 10 awardees worldwide</b> of the D&I Travel Grant from <a className='text-textRed hover:underline' href="https://www.apple.com/"><b>Apple</b></a> for ACL 2025, July 2025
                </li>
                <li className={`relative pl-6 ${BulletCommon}`}>
                [International] <a className='text-textRed hover:underline' href='https://devpost.com/software/faunaloka'><b>3rd Winner</b></a> at GreenHack Challenge Biodiversity App Hackathon, September 2024
                </li>
                <li className={`relative pl-6 ${BulletCommon}`}>
                [International]<b> <a href={SertifSAFMCD2} className='text-textRed hover:underline' title='Download the certificate here!'>Bronze Medal</a> at <a href="https://www.safmc.com.sg/" className='text-textRed hover:underline' title="SAFMC's Website">Singapore Amazing Flying Machine Competition</a> 2023 </b> - D2 Autonomous Drone Category, March 2023
                </li>
                <li className={`relative pl-6 ${BulletCommon}`}>
                [International]<b> <a href={SertifSAFMCD1} className='text-textRed hover:underline' title='Download the certificate here!'>Finalist</a> at <a href="https://www.safmc.com.sg/" className='text-textRed hover:underline' title="SAFMC's Website">Singapore Amazing Flying Machine Competition</a> 2023 </b> - D1 Semi Autonomous Drone Category, March 2023
                </li>
                <li className={`relative pl-6 ${BulletCommon}`}>
                [International] <b>Ganesha Karya </b> from ITB's Ganesha Award for International Competition Winner, October 2023
                </li>
                <li className={`relative pl-6 ${BulletCommon}`}>
                [National] <b>Garuda ACE Fellowship</b> from Indonesia MoECRT, December 2023
                </li>
                <li className={`relative pl-6 ${BulletCommon}`}>
                [National] <a className='text-textRed hover:underline' href={SertifHanaBank}><b>HanaBank Korea</b></a> scholarship awardee, November 2023
                </li>
                <li className={`relative pl-6 ${BulletCommon}`}>
                [National] <a className='text-textRed hover:underline' href={SertifMagenta}><b>Best participant</b></a> of Global Talent Internship Program with 98/100, February 2023
                </li>
                <li className={`relative pl-6 ${BulletCommon}`}>
                [National] <b>Granted scholarships for monthly expenses from Akabri-70 Foundation</b> , August 2021
                </li>
                <li className={`relative pl-6 ${BulletCommon}`}>
                [National] <b>Granted a full scholarship for my tuition fees from KIP-K </b>during my study in ITB, August 2021
                </li>
                <li className={`relative pl-6 ${BulletCommon}`}>
                [National]<b> 1st Place at <a href='https://www.instagram.com/p/B29L0dLHmRg/?hl=en' className='text-textRed hover:underline' title='Watch my video!'>Ruangguru Champion Season 1</a> </b>-  won $1000 USD, August 2019
                </li>
                <li className={`relative pl-6 ${BulletCommon}`}>
                [Regional]<b> 1st Place and Best Speaker at <a href="https://sma.pusatprestasinasional.kemdikbud.go.id/ldbinsdc/#about" className='text-textRed hover:underline' title="LDBI's Website">Lomba Debat Bahasa Indonesia (LDBI)</a> </b>, May 2019
                </li>
                <li className={`relative pl-6 ${BulletCommon}`}>
                [Regional]<b> 1st Place at <a href='https://osn-onmipa-bpti.kemdikbud.go.id/osn.html' className='text-textRed hover:underline' title="KSN's Website">Kompetisi Sains Nasional</a> (Physics) </b>, April 2019
                </li>
            </ul>
            ) : (
            <ul className="text-textGrey text-md text-left font-condensed font-extralight md:w-[95vw] sm:w-[93vw] h-auto">
                <li className={`relative pl-6 mx-10 ${BulletCommon}`}>
                [International] <b>2 Ganesha Karya 2025 </b> from ITB's Anugerah Citra Ganesha for International Competition Winner, November 2025
                </li>
                <li className={`relative pl-6 mx-10 ${BulletCommon}`}>
                [International] <b>1 of 10 awardees worldwide</b> of the D&I Travel Grant from <a className='text-textRed hover:underline' href="https://www.apple.com/"><b>Apple</b></a> for ACL 2025, July 2025
                </li>
                <li className={`relative pl-6 mx-10 ${BulletCommon}`}>
                [International] <a className='text-textRed hover:underline' href='https://devpost.com/software/faunaloka'><b>3rd Winner</b></a> at GreenHack Challenge Biodiversity App Hackathon, September 2024
                </li>
                <li className={`relative pl-6 mx-10 ${BulletCommon}`}>
                [International]<b> <a href={SertifSAFMCD2} className='text-textRed hover:underline' title='Download the certificate here!'>Bronze Medal</a> at <a href="https://www.safmc.com.sg/" className='text-textRed hover:underline' title="SAFMC's Website">Singapore Amazing Flying Machine Competition</a> 2023 </b> - D2 Autonomous Drone Category, March 2023
                </li>
                <li className={`relative pl-6 mx-10 ${BulletCommon}`}>
                [International]<b> <a href={SertifSAFMCD1} className='text-textRed hover:underline' title='Download the certificate here!'>Finalist</a> at <a href="https://www.safmc.com.sg/" className='text-textRed hover:underline' title="SAFMC's Website">Singapore Amazing Flying Machine Competition</a> 2023 </b> - D1 Semi Autonomous Drone Category, March 2023
                </li>
                <li className={`relative pl-6 mx-10 ${BulletCommon}`}>
                [International] <b>Ganesha Karya </b> from ITB's Ganesha Award for International Competition Winner, October 2023
                </li>
                <li className={`relative pl-6 mx-10 ${BulletCommon}`}>
                [National] <b>Garuda ACE Fellowship</b> from Indonesia MoECRT, December 2023
                </li>
                <li className={`relative pl-6 mx-10 ${BulletCommon}`}>
                [National] <a className='text-textRed hover:underline' href={SertifHanaBank}><b>HanaBank Korea</b></a> scholarship awardee, November 2023
                </li>
                <li className={`relative pl-6 mx-10 ${BulletCommon}`}>
                [National] <a className='text-textRed hover:underline' href={SertifMagenta}><b>Best participant</b></a> of Global Talent Internship Program with 98/100, February 2023
                </li>
                <li className={`relative pl-6 mx-10 ${BulletCommon}`}>
                [National] <b>Granted scholarships for monthly expenses from Akabri-70 Foundation</b> , August 2021
                </li>
                <li className={`relative pl-6 mx-10 ${BulletCommon}`}>
                [National] <b>Granted a full scholarship for my tuition fees from KIP-K </b>during my study in ITB, August 2021
                </li>
                <li className={`relative pl-6 mx-10 ${BulletCommon}`}>
                [National]<b> 1st Place at <a href='https://www.instagram.com/p/B29L0dLHmRg/?hl=en' className='text-textRed hover:underline' title='Watch my video!'>Ruangguru Champion Season 1</a> </b>-  won $1000 USD, August 2019
                </li>
                <li className={`relative pl-6 mx-10 ${BulletCommon}`}>
                [Regional]<b> 1st Place and Best Speaker at <a href="https://sma.pusatprestasinasional.kemdikbud.go.id/ldbinsdc/#about" className='text-textRed hover:underline' title="LDBI's Website">Lomba Debat Bahasa Indonesia (LDBI)</a> </b>, May 2019
                </li>
                <li className={`relative pl-6 mx-10 ${BulletCommon}`}>
                [Regional]<b> 1st Place at <a href='https://osn-onmipa-bpti.kemdikbud.go.id/osn.html' className='text-textRed hover:underline' title="KSN's Website">Kompetisi Sains Nasional</a> (Physics) </b>, April 2019
                </li>
            </ul>
            )}
            <br/>
        </div>
    );
};

export default Award